// removed by extract-text-webpack-plugin
module.exports = {"description":"_3shXvWcEien38pDakUh46S"};


//////////////////
// WEBPACK FOOTER
// ./components/Users/styles.less
// module id = 1481
// module chunks = 0